/**
 * @generated SignedSource<<138686a38facd5db9997263faae9dd20>>
 * @relayHash 6ffd2371ebced88604525fd7d233eabd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f648854cde48e120ccbf6d23bde4e25f1202bc1ec5e463f370627e70d5b54b81

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraOptionColorInput = "BLUE" | "BLUE_DARKER" | "BLUE_DARKEST" | "BLUE_LIGHTER" | "BLUE_LIGHTEST" | "GREEN" | "GREEN_DARKER" | "GREEN_DARKEST" | "GREEN_LIGHTER" | "GREEN_LIGHTEST" | "GREY" | "GREY_DARKER" | "GREY_DARKEST" | "GREY_LIGHTER" | "GREY_LIGHTEST" | "LIME" | "LIME_DARKER" | "LIME_DARKEST" | "LIME_LIGHTER" | "LIME_LIGHTEST" | "MAGENTA" | "MAGENTA_DARKER" | "MAGENTA_DARKEST" | "MAGENTA_LIGHTER" | "MAGENTA_LIGHTEST" | "ORANGE" | "ORANGE_DARKER" | "ORANGE_DARKEST" | "ORANGE_LIGHTER" | "ORANGE_LIGHTEST" | "PURPLE" | "PURPLE_DARKER" | "PURPLE_DARKEST" | "PURPLE_LIGHTER" | "PURPLE_LIGHTEST" | "RED" | "RED_DARKER" | "RED_DARKEST" | "RED_LIGHTER" | "RED_LIGHTEST" | "TEAL" | "TEAL_DARKER" | "TEAL_DARKEST" | "TEAL_LIGHTER" | "TEAL_LIGHTEST" | "YELLOW" | "YELLOW_DARKER" | "YELLOW_DARKEST" | "YELLOW_LIGHTER" | "YELLOW_LIGHTEST" | "%future added value";
export type JiraBulkLabelColorUpdateInput = {
  labelColorUpdate: ReadonlyArray<JiraBulkLabelColorUpdateInputItem>;
  projectId: string;
};
export type JiraBulkLabelColorUpdateInputItem = {
  color?: JiraOptionColorInput | null | undefined;
  fieldId: string;
  label: string;
};
export type view_labelsUpdateColorMutation$variables = {
  input: JiraBulkLabelColorUpdateInput;
};
export type view_labelsUpdateColorMutation$data = {
  readonly jira: {
    readonly bulkUpdateLabelColor: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type view_labelsUpdateColorMutation$rawResponse = {
  readonly jira: {
    readonly bulkUpdateLabelColor: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type view_labelsUpdateColorMutation = {
  rawResponse: view_labelsUpdateColorMutation$rawResponse;
  response: view_labelsUpdateColorMutation$data;
  variables: view_labelsUpdateColorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraBulkLabelColorUpdatePayload",
        "kind": "LinkedField",
        "name": "bulkUpdateLabelColor",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "view_labelsUpdateColorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "view_labelsUpdateColorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f648854cde48e120ccbf6d23bde4e25f1202bc1ec5e463f370627e70d5b54b81",
    "metadata": {},
    "name": "view_labelsUpdateColorMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8484ef1e9f98b05dc2bf5a099c2820e8";

export default node;
